import React, { useEffect } from "react";
import moment from "moment-jalaali";
import { Pagination, usePagination } from "ui";
import { useAppSelector } from "store";
import { useTransactions } from "../api/get-transactions";
import { TransactionsTable } from "./transaction-table";
import { ActionBar } from "./action-bar";

import styles from "./transactions.module.scss";
import { Spinner } from "react-bootstrap";

export const TransactionsList = () => {
  const {
    page,
    pageSize,
    pageCount,
    handlePageChange,
    handlePageCountChange,
    handlePageSizeChange,
  } = usePagination();
  const { transactionFilter } = useAppSelector((state) => state.transactions);
  const { data, error, isFetched, isFetching, refetch } = useTransactions({
    params: {
      PageNumber: page,
      PageSize: pageSize,
      TerminalId: transactionFilter?.terminalId,
      FromDate: moment(transactionFilter.startDate).format("YYYY-MM-DD"),
      ToDate: moment(transactionFilter.endDate).format("YYYY-MM-DD"),
      BuyId: transactionFilter.BuyId,
      TrackingNumber: transactionFilter.TrackingNumber,
    },
    options: {
      enabled: !!transactionFilter?.terminalId,
    },
  });

  useEffect(() => {
    if (isFetched && data) {
      handlePageCountChange(Math.ceil(data.totalRecord / data.pageSize));
    }
  }, [data, isFetched, handlePageCountChange]);

  return (
    <div className={styles.transactions_container}>
      <ActionBar refetch={refetch} isLoading={isFetching}  transactions={data?.data || []}/>
      <div className="custom-box d-flex gap-5 w-100">
        {isFetching ? (
          <div className="flex-center w-100">
            <Spinner />
          </div>
        ) : (
          <>
            <div className="d-flex gap-1">
              <span>تعداد تمام تراکنش ها:</span>
              <strong>{data?.totalRecord?.toLocaleString()}</strong>
            </div>
            <div className="d-flex gap-1">
              <span> تعداد تراکنش های موفق:</span>
              <strong className="text-success">
                {data?.totalSuccessTransaction?.toLocaleString()}
              </strong>
            </div>
            <div className="d-flex gap-1">
              <span>جمع مبلغ تراکنش های موفق:</span>
              <strong>
                {data?.totalSuccessAmount?.toLocaleString()}&nbsp;ریال{" "}
              </strong>
            </div>
          </>
        )}
      </div>
      <div className={styles.table_container}>
        <TransactionsTable
          page={page}
          pageSize={pageSize}
          transactions={data?.data}
          error={error?.message}
          isLoading={isFetching}
        />
        <Pagination
          page={page}
          pageSize={pageSize}
          pageCount={pageCount}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onPageCountChange={handlePageCountChange}
        />
      </div>
    </div>
  );
};
